import router from '../../router'
import store from '../../store'
import { AppHeader } from '../header'
import { AppSidebar } from '../sidebar'

export default {
  name: 'app',
  components: {
    AppHeader,
    AppSidebar
  },
  data () {
    return {
      isLoading: true,
      loggedIn: false
    }
  },
  computed: {
    isLayerOpened() {
      return this.$store.getters['isLayerOpened']
    }
  },
  mounted () {
    this.$store.watch((state) => {
      this.loggedIn = store.state.auth.isLoggedIn
    })

    this.$store.dispatch('users/getMe')
      .then(response => {
        this.$store.dispatch('auth/updateIsLoggedIn', true)
        this.$store.dispatch('auth/updateUser', response.body.data)

        this.isLoading = false
        this.$store.state.loading = false

        if (response.status === 200) {
          this.loggedIn = true
        } else {
          this.loggingIn = false
        }

        return response
      })
      .catch((errorResponse) => {

        if (errorResponse.status === 422) {
          this.isLoading = false
          router.push({ name: 'Login' })
        }
        return errorResponse
      })
  },
  watch: {
    isLayerOpened(newValue) {
      // Add a className to the body element to prevent scrolling if the focus is on an overlay (e.g. modals)
      this.$el.parentNode.className = newValue ? 'opened-layer' : ''
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/app/app.js